import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useGlobalContext from '../../../Hooks/useGlobalContext';
import { Typography} from '@mui/material';
import {
  ASSETS,
  ASSETS_EDIT,
  ASSETS_NEW,
  BOXES_ALL,
  BOXES_NEW,
  BOXES_EDIT,
  LOTS,
  LOTS_EDIT,
  LOTS_NEW,
  ASSETS_FILE_LOAD,
  ASSETS_MANUAL_LOAD,
  EVENTS_ASSETS_FILTER,
  EVENTS_FILE_LOAD,
  EVENTS_ALL,
  ASSETS_MASSIVE_EDIT,
  COMPANY_ALL,
  COMPANY_NEW,
  COMPANY_EDIT,
  EVENTS_MASSIVE,
  EVENTS_MASSIVE_MANUAL,
  TRANSFERS_MASSIVE,
  TRANSFERS_MASSIVE_MANUAL,
  USER_EDIT,
  QR_TEMPLATES,
  QR_IDENTECO,
  QR_PRODUKTO_TRUPO,
  QR_IDENTECO_TRUPO,
  USER_DELEGATIONS,
  USER_DELEGATIONS_ALL,
  USER_DELEGATIONS_COMPANY_ALL,
  TRANSFERRED_ASSETS,
  ACTIVITIES,
  LOGICAL_DELETED_ASSETS,
  REPORTS,
  TRANSFERS,
  EVENTS,
  NAMED_ENTITIES,
  REQUIRED_FIELDS_ERROR,
  QRS_METRICS,
  QRS_LOGS,
  ASSETS_ORACLES,
  NEW_ASSETS_ORACLES,
  COMPANY_RENEWAL_ERROR,
  CONTROL_PANEL,
  VALIDATIONS,
  VALIDATIONS_COMPANIES,
  VALIDATIONS_ASSETS
} from '../../../constants/paths';
import useThemeContext from '../../../Hooks/useThemeContext';
import LanguageSelect from '../../../Components/LanguageSelect';
import { useTranslation } from 'react-i18next';
import { getTranslationForBox } from '../../../Utils/translationForBox';
import LoadingHeader from '../Loading/LoadingHeader';

function Header(props) {
  let { activeTheme, logoTenant } = useThemeContext();
  const location = useLocation();
  const [title, setTitle] = useState('');
  const [subTitle, setSubTitle] = useState('');
  const [currentLogo, setCurrentLogo] = useState(logoTenant);
  let { selectedBox, selectedLang, loading, initiatedItemsComplete } = useGlobalContext();
  const { t } = useTranslation();

  useEffect(() => {
    let titleTemp = '';
    let subTitleTemp = '';

    if(location.pathname.includes(QRS_LOGS.substring(0, QRS_LOGS.indexOf('/:')))){
      titleTemp = getTranslationForBox('header.qrs_logs', selectedBox.subtype, t, '.title');
      subTitleTemp = getTranslationForBox('header.qrs_logs', selectedBox.subtype, t, '.subtitle');
    } else {
      switch (location.pathname) {
        //ADMINISTRACION
        case COMPANY_ALL:
          titleTemp = t('header.company_all.title');
          subTitleTemp = t('header.company_all.subtitle');
          break;

        case COMPANY_NEW:
          titleTemp = t('header.company_new.title');
          subTitleTemp = t('header.company_new.subtitle');
          break;

        case COMPANY_EDIT:
          titleTemp = t('header.company_edit.title');
          subTitleTemp = t('header.company_edit.subtitle');
          break;

        case BOXES_ALL:
          titleTemp = t('header.boxes_all.title');
          subTitleTemp = t('header.boxes_all.subtitle');
          break;

        case BOXES_NEW:
          titleTemp = t('header.boxes_new.title');
          subTitleTemp = t('header.boxes_new.subtitle');
          break;

        case BOXES_EDIT:
          titleTemp = t('header.boxes_edit.title');
          subTitleTemp = t('header.boxes_edit.subtitle');
          break;

        case USER_EDIT:
          titleTemp = t('header.user_edit.title');
          subTitleTemp = t('header.user_edit.subtitle');
          break;

        case USER_DELEGATIONS:
          titleTemp = t('header.user_delegations.title');
          subTitleTemp = t('header.user_delegations.subtitle');
          break;

        case USER_DELEGATIONS_ALL:
          titleTemp = t('header.user_delegations_all.title');
          subTitleTemp = t('header.user_delegations_all.subtitle');
          break;

        case USER_DELEGATIONS_COMPANY_ALL:
          titleTemp = t('header.user_delegations_company_all.title');
          subTitleTemp = t('header.user_delegations_company_all.subtitle');
          break;

        case QR_IDENTECO:
          titleTemp = t('header.qr_identeco.title');
          subTitleTemp = t('header.qr_identeco.subtitle');
          break;

        case QR_PRODUKTO_TRUPO:
          titleTemp = t('header.qr_produkto_trupo.title');
          subTitleTemp = t('header.qr_produkto_trupo.subtitle');
          break;

        case QR_IDENTECO_TRUPO:
          titleTemp = t('header.qr_identeco_trupo.title');
          subTitleTemp = t('header.qr_identeco_trupo.subtitle');
          break;

        //ASSETS
        case ASSETS_FILE_LOAD:
          titleTemp = getTranslationForBox('header.assets_file_load', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.assets_file_load', selectedBox.subtype, t, '.subtitle');
          break;

        case ASSETS:
          titleTemp = getTranslationForBox('header.assets', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.assets', selectedBox.subtype, t, '.subtitle');
          break;

        case ASSETS_NEW:
          titleTemp = getTranslationForBox('header.assets_new', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.assets_new', selectedBox.subtype, t, '.subtitle');
          break;

        case ASSETS_EDIT:
          titleTemp = getTranslationForBox('header.assets_edit', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.assets_edit', selectedBox.subtype, t, '.subtitle');
          break;

        case ASSETS_MANUAL_LOAD:
          titleTemp = getTranslationForBox('header.assets_manual_load', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.assets_manual_load', selectedBox.subtype, t, '.subtitle');
          break;

        case ASSETS_MASSIVE_EDIT:
          titleTemp = getTranslationForBox('header.assets_massive_edit', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.assets_massive_edit', selectedBox.subtype, t, '.subtitle');
          break;

        case EVENTS:
          titleTemp = getTranslationForBox('header.events', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.events', selectedBox.subtype, t, '.subtitle');
          break;

        case EVENTS_ALL:
          titleTemp = getTranslationForBox('header.assets_all', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.assets_all', selectedBox.subtype, t, '.subtitle');
          break;

        case EVENTS_ASSETS_FILTER:
          titleTemp = getTranslationForBox('header.assets_assets_filter', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.assets_assets_filter', selectedBox.subtype, t, '.subtitle');
          break;

        case EVENTS_FILE_LOAD:
          titleTemp = getTranslationForBox('header.events_file_load', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.events_file_load', selectedBox.subtype, t, '.subtitle');
          break;

        case EVENTS_MASSIVE:
          titleTemp = getTranslationForBox('header.events_massive', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.events_massive', selectedBox.subtype, t, '.subtitle');
          break;

        case EVENTS_MASSIVE_MANUAL:
          titleTemp = getTranslationForBox('header.events_massive_manual', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.events_massive_manual', selectedBox.subtype, t, '.subtitle');
          break;

        case TRANSFERS:
          titleTemp = getTranslationForBox('header.transfers', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.transfers', selectedBox.subtype, t, '.subtitle');
          break;

        case TRANSFERS_MASSIVE:
          titleTemp = getTranslationForBox('header.transfers_massive', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.transfers_massive', selectedBox.subtype, t, '.subtitle');
          break;

        case TRANSFERS_MASSIVE_MANUAL:
          titleTemp = getTranslationForBox('header.transfers_massive_manual', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.transfers_massive_manual', selectedBox.subtype, t, '.subtitle');
          break;

        case TRANSFERRED_ASSETS:
          titleTemp = getTranslationForBox('header.transferred_assets', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.transferred_assets', selectedBox.subtype, t, '.subtitle');
          break;
        
        case ASSETS_ORACLES:
          titleTemp = getTranslationForBox('header.assets_oracles', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.assets_oracles', selectedBox.subtype, t, '.subtitle');
          break;

        case CONTROL_PANEL:
          titleTemp = getTranslationForBox('header.control_panel', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.control_panel', selectedBox.subtype, t, '.subtitle');
          break;
    
        case NEW_ASSETS_ORACLES:
          titleTemp = getTranslationForBox('header.new_assets_oracles', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.new_assets_oracles', selectedBox.subtype, t, '.subtitle');
          break;

        case LOTS:
          titleTemp = getTranslationForBox('header.lots', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.lots', selectedBox.subtype, t, '.subtitle');
          break;

        case LOTS_NEW:
          titleTemp = getTranslationForBox('header.lots_new', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.lots_new', selectedBox.subtype, t, '.subtitle');
          break;

        case LOTS_EDIT:
          titleTemp = getTranslationForBox('header.lots_edit', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.lots_edit', selectedBox.subtype, t, '.subtitle');
          break;

        case QR_TEMPLATES:
          titleTemp = getTranslationForBox('header.qr_templates', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.qr_templates', selectedBox.subtype, t, '.subtitle');
          break;

        case QRS_METRICS:
          titleTemp = getTranslationForBox('header.qrs_metrics', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.qrs_metrics', selectedBox.subtype, t, '.subtitle');
          break;

        case ACTIVITIES:
          titleTemp = getTranslationForBox('header.activities', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.activities', selectedBox.subtype, t, '.subtitle');
          break;

        case LOGICAL_DELETED_ASSETS:
          titleTemp = getTranslationForBox('header.logicalDeletedAssets', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.logicalDeletedAssets', selectedBox.subtype, t, '.subtitle');
          break;

        case REPORTS:
          titleTemp = getTranslationForBox('header.reports', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.reports', selectedBox.subtype, t, '.subtitle');
          break;

        case REQUIRED_FIELDS_ERROR:
          titleTemp = getTranslationForBox('header.requiredFields', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.requiredFields', selectedBox.subtype, t, '.subtitle');
          break;
        case NAMED_ENTITIES:
          titleTemp = getTranslationForBox('header.namedEntities', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.namedEntities', selectedBox.subtype, t, '.subtitle');
          break;

        case COMPANY_RENEWAL_ERROR:
          titleTemp = getTranslationForBox('header.companyRenewal', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.companyRenewal', selectedBox.subtype, t, '.subtitle');
          break;

        case VALIDATIONS:
          titleTemp = getTranslationForBox('header.validations', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.validations', selectedBox.subtype, t, '.subtitle');
          break;
        
        case VALIDATIONS_COMPANIES:
          titleTemp = getTranslationForBox('header.validationsCompanies', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.validationsCompanies', selectedBox.subtype, t, '.subtitle');
          break;
        
        case VALIDATIONS_ASSETS:
          titleTemp = getTranslationForBox('header.validationsAssets', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.validationsAssets', selectedBox.subtype, t, '.subtitle');
          break;

        default:
          titleTemp = getTranslationForBox('header.default', selectedBox.subtype, t, '.title');
          subTitleTemp = getTranslationForBox('header.default', selectedBox.subtype, t, '.subtitle');
      }
    }
    setTitle(titleTemp);
    setSubTitle(subTitleTemp);
  }, [location.pathname, selectedLang]);

  useEffect(() => {
    setCurrentLogo(logoTenant);
  }, [logoTenant]);

  return (
    <div style={{
      display: 'flex', justifyContent: 'space-around', width: '-webkit-fill-available',
      background: `${activeTheme.palette.primary.contrastText}`,
      margin: '0.8rem 0rem 0.8rem 0rem'
    }}>
      {loading || !initiatedItemsComplete
      ? <LoadingHeader title={title} subTitle={subTitle}/>
      :
        <div className="col-10">
          <Typography variant="h3" fontSize='2rem'  color={'#666666'}>
            {title}
          </Typography>
          <Typography variant="subtitle1" color={'grey'}>
            {subTitle}
          </Typography>
        </div>
      }
      <div className="col-2" align="right" style={{ marginTop: '15px' }}>
        {currentLogo && (
          <img
            style={{ maxHeight: '30px', width: 'auto', paddingRight: '10px' }}
            src={currentLogo}
            alt=""
          />
        )}
        <LanguageSelect />
      </div>
    </div>
  );
}

export default Header;
